module.exports = __webpack_public_path__ + "img/section1Modelm.bd083441.png";